export default "__VITE_ASSET__G_skWuB2__"